<div class="bn-update-notification__title text-400-semi-bold mb-2">New version available</div>
<div class="bn-update-notification__content mb-3">
  <p>New version of bunny.net dashboard was just deployed. To get the latest updates and features please reload the page.</p>
</div>
<div>
  <button
    bn-web-ui-button
    itemStyle="secondary"
    size="md"
    (click)="onRefreshAppClick()">
    Reload
  </button>
</div>
<div
  class="xmark position-absolute cursor-pointer"
  tooltip="Hide for 15 minutes"
  (click)="onCloseClick()">
  <fa-icon
    icon="xmark"
    size="lg" />
</div>
